export default __webpack_public_path__ + "static/media/seat1.21e15983.jpeg";